import { createContext } from "react";
import { TelegramWebappQueryData } from "@shared/types";

export const TelegramWebAppContext = createContext<
  | {
      telegramStartValue?: TelegramWebappQueryData;
      initData?: string;
      urlInitData?: string;
      telegramInitData?: string;
    }
  | undefined
>(undefined);
